module.exports = __webpack_public_path__ + "img/tpd_icon.b42baba7.svg";